const apiKey = 'AIzaSyCVjPrjjHXCZBm66T3a3kC0A7MFYaROlZY'
const defaultCenter = {
  lat: -6.1754,
  lng: 106.8272
}
const region = 'ID'
const language = 'id'
const defaultZoom = 14

export {
  apiKey,
  region,
  language,
  defaultCenter,
  defaultZoom
}